module.exports = __webpack_public_path__ + "img/san_pedro_square.0f8d0ccb.png";